export default {
  'header:account': 'Account',
  'header:account:greeting': 'Hi, {firstName}',
  'header:cart': 'Cart',
  'header:search': 'Search',
  'header:pet-profile': 'Your dog',
  'header:pet-profile-cat': 'Your cat',
  'header:pet-profile:badge': 'New',
  'header:discount': 'Discount',
  'header:navigation-dogs': 'Dogs',
  'header:navigation-cats': 'Cats',
  'header:navigation:mobile:back': 'Back',
  'header:navigation:mobile:magazine': 'Magazine',
  'header:navigation:mobile:consulting': 'Food Advice',
  'header:usp:trusted-shop': '4.89/5.0 "Very good" - over 4,856 reviews',
  'header:usp:faq-help': 'FAQ & Help',
  'header:usp:free-shipping': 'Free shipping from €50',
  'header:usp:recipes': 'Selected and delicious recipes',
  'header:usp:acceptance': 'High acceptance',
  'header:usp:no-grains': '100% real meat - 0% grain',
  'header:usp:ratings': '98% Positive reviews: over 55,000 happy pets',
  'header:usp:donations':
    '1000% pet love – regular donations for those in need.',
  'header:usp:good-choice': 'Good call! Your furry friend will thank you.',
  'header:search:placeholder': 'Find food',
  'header:search:last-queries': 'Recent Searches',
  'header:search:delete': 'DELETE',
  'header:subs-promo-bar:title': 'Save on every delivery!',
  'header:subs-promo-bar:info-link': 'Learn more',

  'header:usp:free-shipping:EC': 'Free shipping from €60 ',
  'header:usp:free-shipping:NC': '<b> Free shipping for new customers </b>',
  'header:tastyguarantee:money-back:modal:title':
    'Pets Deli solves food problems – proven.',
  'header:tastyguarantee:money-back:modal:sub-title':
    "Our promise: <b>If it doesn't taste good, it doesn't stay.</b> If your furry friend isn't a fan, we'll send you a free alternative – no questions asked.",
  'header:tastyguarantee:money-back:modal:list-title': "It's that simple:",
  'header:tastyguarantee:money-back:modal:step-1':
    "Just fill out our contact form – you'll find it right here. Having an issue? Select 'Taste Guarantee' under <a>Submit request – PETS DELI</a>",
  'header:tastyguarantee:money-back:modal:step-2':
    "Get free advice from our nutrition team – and let's find the perfect food alternative for your furry friend.",
  'header:tastyguarantee:money-back:modal:step-3':
    "We'll make sure your new product arrives as quickly as possible.",
  'header:usp:test:text-1': 'Free delivery for new customers',
  'header:usp:test:text-2': '91% solved food problems',
  'header:usp:test:text-3': '10% off with every subscription',
  'header:usp:test:text-4': 'Over 98,654 satisfied customers',
};
